var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFirebase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFC24A;}\r\n\t.st1{fill:#F4BD62;}\r\n\t.st2{fill:#F6820C;}\r\n\t.st3{fill:#FDE068;}\r\n\t.st4{fill:#FCCA3F;}\r\n\t.st5{fill:#EEAB37;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    className: "st0",
    d: "M117.1,362.1l2.2-3.1l104.5-198.3l0.2-2.1L177.9,72c-3.9-7.3-14.7-5.4-16,2.7L117.1,362.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    className: "st1",
    d: "M257.6,224.1l34.3-35.1l-34.3-65.5c-3.3-6.2-12.4-6.2-15.6,0l-18.3,35v3L257.6,224.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_4_",
    className: "st2",
    points: "117.1,362.1 118.1,361.1 121.7,359.6 255.5,226.4 257.1,221.8 223.8,158.2  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    className: "st3",
    d: "M261.9,429.3l121-67.5l-34.6-212.9c-1.1-6.7-9.3-9.3-14-4.5L117.1,362.1l120.4,67.2 C245,433.6,254.3,433.6,261.9,429.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    className: "st4",
    d: "M381.9,361.2L347.6,150c-1.1-6.6-7.9-9.3-12.6-4.6L118.4,361.7l119,66.5 c7.5,4.2,16.7,4.2,24.3,0L381.9,361.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    className: "st5",
    d: "M261.9,427.3c-7.6,4.2-16.9,4.2-24.5,0L118,361.1l-1,1l120.4,67.2c7.6,4.2,16.9,4.2,24.5,0 l121-67.5l-0.3-1.8L261.9,427.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirebase);
export default __webpack_public_path__ + "static/media/firebase.ecddc65b1dd6d0decdf5b629717b2f05.svg";
export { ForwardRef as ReactComponent };